"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.3979 2.414 19.1846 19.1906-1.3978 1.3965L19.1839 22H4V6.8115l-3-3.001L2.3979 2.414zM6 20V8.812L17.1845 20H6zm.8114-16 3.9988 4h4.6902l-.0027-2H18v9.1921l2 2.0006V4h-4.6563c-.0783-.2831-.1966-.5629-.3753-.819C14.3643 2.315 13.3209 2 11.9971 2c-1.353 0-2.4192.3063-3.0168 1.1953-.1757.2615-.2841.5377-.3526.8047H6.8114zm3.6857 1.5714c0-.3702.0016-.6417.0313-.8744.0287-.225.0752-.3315.1119-.386.028-.0417.2117-.311 1.3568-.311 1.0793 0 1.286.2607 1.331.3253.1149.1647.169.4734.169 1.2461L13.4977 6h-3.0006v-.4286z"
  })];
};

exports.default = _default;